import { COVER_API_PATH } from 'constants/apiPaths';
import withExhibitionDetails from 'modules/Exhibition/hoc/withExhibitionDetails';
import { ExhibitionCover as ExhibitionCoverComponent } from './ExhibitionCover';

export const ExhibitionCover = withExhibitionDetails(
  ExhibitionCoverComponent,
  COVER_API_PATH,
);
